module.exports = __webpack_public_path__ + "2e86ff727ad4f637018483f6035ba582.pdf";